import { equals, type MessageInitShape } from "@bufbuild/protobuf";
import { NotificationTemplateSchema, NotificationTemplateService, type NotificationTemplate } from "#gen/notification_templates/v1/notification_templates_pb.js";
import { createClient, type ClientOptions } from "#lib/api/api.js";
import { handleError } from "#lib/api/error.js";
import { PUBLIC_URLS } from "#lib/url.js";
import type { Client } from "@connectrpc/connect";

export function equalTemplates(a: Record<string, NotificationTemplate | undefined>, b: Record<string, NotificationTemplate | undefined>): boolean {
	const aKeys = new Set(Object.keys(a));
	const bKeys = new Set(Object.keys(b));
	if (aKeys.size !== bKeys.size) {
		return false;
	}
	for (const key of aKeys) {
		if (!bKeys.has(key)) {
			return false;
		}
		if (a[key] === undefined && b[key] === undefined) {
			continue;
		}
		if (a[key] === undefined || b[key] === undefined) {
			return false;
		}
		if (!equals(NotificationTemplateSchema, a[key], b[key])) {
			return false;
		}
	}
	return true;
}

export class NotificationTemplateClient {
	private client: Client<typeof NotificationTemplateService>;

	constructor(options?: () => ClientOptions) {
		this.client = createClient(PUBLIC_URLS.notificationTemplates || "/", NotificationTemplateService, options);
	}

	async getTemplate(id: string): Promise<NotificationTemplate> {
		try {
			const res = await this.client.getTemplate({ id });
			return res.template!;
		} catch (e) {
			throw handleError(e);
		}
	}
	async createTemplate(template: MessageInitShape<typeof NotificationTemplateSchema>): Promise<NotificationTemplate> {
		try {
			const res = await this.client.createTemplate({ template });
			return res.template!;
		} catch (e) {
			throw handleError(e);
		}
	}
	async updateTemplate(template: MessageInitShape<typeof NotificationTemplateSchema>): Promise<NotificationTemplate> {
		try {
			const res = await this.client.updateTemplate({ template });
			return res.template!;
		} catch (e) {
			throw handleError(e);
		}
	}
}
